import { render, staticRenderFns } from "./bulletinBoardList.vue?vue&type=template&id=1794598a&scoped=true"
import script from "./bulletinBoardList.vue?vue&type=script&lang=js"
export * from "./bulletinBoardList.vue?vue&type=script&lang=js"
import style0 from "./bulletinBoardList.vue?vue&type=style&index=0&id=1794598a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1794598a",
  null
  
)

export default component.exports